import React, { CSSProperties } from "react"
import { Map, MapProps, ControlPosition, useMap } from "@vis.gl/react-google-maps"
import { Box } from "@chakra-ui/react"
import ZoomControl from "./ZoomControl"
import { useGoogleMapsEffect } from "../lib/hooks/useGoogleMapsEffect"
import { useMapBBox } from "../components/providers/MapBBoxProvider"
import { createBBoxFromGoogleMapBounds } from "../lib/helpers/googleMap"
import { useMapSettings } from "../components/providers/MapSettingsProvider"
import lodash from "lodash"

interface GMapProps extends MapProps {
  mapId: string
  containerStyle?: CSSProperties
  zoomControl?: boolean
  shareCurrentView?: boolean
  children?: React.ReactNode
}

const GMap: React.FC<GMapProps> = ({
  mapId,
  initialBounds,
  containerStyle,
  zoomControl,
  shareCurrentView,
  children,
  ...props
}) => {
  const { setCurrentBBox } = useMapBBox()

  const { googleMapsId, googleMapsType } = useMapSettings()

  const map = useMap(mapId)

  useGoogleMapsEffect(
    mapId,
    () => {
      if (!initialBounds) return
      if (!lodash.isEqual(map?.getBounds(), initialBounds)) {
        map?.fitBounds(initialBounds, 0)
      }
    },
    [initialBounds],
  )

  const handleIdleMap = () => {
    if (shareCurrentView) {
      const bounds = map?.getBounds()
      if (bounds) {
        const bbox = createBBoxFromGoogleMapBounds(bounds)
        setCurrentBBox(bbox)
      }
    }
  }

  return (
    <Box style={containerStyle}>
      <Map
        {...props}
        id={mapId}
        initialBounds={initialBounds}
        mapId={googleMapsId}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        mapTypeId={googleMapsType}
        onIdle={handleIdleMap}
      >
        {zoomControl !== false && <ZoomControl mapId={mapId} position={ControlPosition.TOP_RIGHT} />}
        {children}
      </Map>
    </Box>
  )
}

export default GMap
